<template>
    <div :class="{'element': true, 'error': errors.has(label), 'focused':focused, 'required': required }">
        <label :class="{'float': true, 'active': active}" :for="label">{{ label }}</label>
        <v-select v-validate="required" :data-vv-scope="scope" v-if="!multiple" v-model="value" :name="label" :id="label" label="name" :options="list" :placeholder="label" @input="setValue()"></v-select>
        <v-select v-validate="required" :data-vv-scope="scope" v-if="multiple" multiple v-model="value" :name="label" :id="label" label="name" :options="list" :placeholder="label" @input="setValue()"></v-select>
        <!--<input v-validate="required" v-model="value" :id="label" :name="label" :type="type" :placeholder="label" @focus="focused = true" @blur="focused = false">-->
        <span v-show="errors.has(scope+'.'+label)" class="error">{{ errors.first(scope+'.'+label) }}</span>
        <input type="hidden" v-model="valueHidden" :name="label" :id="label">
    </div>
</template>
<script type='text/babel'>
    import element from '../../element'

    export default {
        mixins: [element],
        props: ['list', 'multiple', 'required'],
        data: () => ({
            valueHidden: ''
        }),
        methods: {
            setValue() {
                this.valueHidden = this.multiple ? _.join(_.map(this.value,'code')) : this.value.code
            }
        }
    };
</script>
